import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const billingPaymentAdapterReadinessResponseSchema = jsonObject
export const billingPaymentAdapterCredentialMetadataReadinessResponseSchema = jsonObject
export const billingPaymentAdapterOperationReadinessResponseSchema = jsonObject
export type BillingPaymentAdapterReadinessResponse = z.infer<typeof billingPaymentAdapterReadinessResponseSchema>
export type BillingPaymentAdapterCredentialMetadataReadinessResponse = z.infer<typeof billingPaymentAdapterCredentialMetadataReadinessResponseSchema>
export type BillingPaymentAdapterOperationReadinessResponse = z.infer<typeof billingPaymentAdapterOperationReadinessResponseSchema>
